<template>
  <nav v-if="crumbs.length" class="workspace-breadcrumb mb-3" data-test="workspace-breadcrumb" aria-label="breadcrumb">
    <ol class="breadcrumb bg-transparent p-0 mb-0">
      <li v-for="(crumb, index) in crumbs" :key="index" class="breadcrumb-item" :class="{ active: !crumb.to }">
        <router-link v-if="crumb.to" :to="crumb.to" data-test="workspace-breadcrumb-back">
          <i v-if="index === 0" class="mdi mdi-chevron-left align-middle"></i>{{ crumb.label }}
        </router-link>
        <span v-else>{{ crumb.label }}</span>
      </li>
    </ol>
  </nav>
</template>

<script>
import { crumbsFor } from "./workspace-breadcrumb";

/** TKP-143: çalışma alanı alt ekranlarında listeye dönüş kırıntısı (layout'ta, her alt ekranın üstünde). */
export default {
  computed: {
    workspace() {
      return this.$store.getters["switchWorkspace/selected"];
    },
    crumbs() {
      return crumbsFor(this.$route.path, this.workspace, (k) => this.$t(k));
    },
  },
};
</script>

<style lang="scss" scoped>
.workspace-breadcrumb .breadcrumb-item a {
  color: #556ee6;
}
.workspace-breadcrumb .breadcrumb-item.active {
  color: #495057;
  font-weight: 500;
}
</style>
